import {each, isNumber, isString, map, reduce} from 'lodash';
import {Model} from './model';

export class CatClient extends Model {
  public CodCat: string;
  public NomCat: string;

  constructor(data?: object) {
    super(data);
  }

  public static cast(data: object): CatClient {
    return new CatClient(data);
  }

  public static casts(data: object[]): CatClient[] {
    return map(data, c => new CatClient(c));
  }
}
